import React, {useContext, useEffect, useState} from 'react'
import FinancialTableRow from './FinancialTableRow'
import { currencyToSymbol, formatDateTimeString } from "../../utils/commonUtils";
import { UserSettingsContext } from '../../../context/UserSettingsContext';
import Loading from '../../Loading';

const FinancialDataSummary = ({ financialData, stockPriceData, companyInfo, accountingStandard, dividendData, stockCurrency }) => {
    const { selectableAccounts } = useContext(UserSettingsContext);
    const unit = currencyToSymbol(financialData?.reported_currency);
    const [showMarketData, setShowMarketData] = useState(false);
    
    useEffect(() => {
        if (!['JPY', 'USD'].includes(financialData?.reported_currency)) {
            setShowMarketData(false);
        } else {
            setShowMarketData(true);
        }
    }, [financialData])
    
    if (!financialData) {
        return <Loading />
    }
    const stockCurrencyUnit = currencyToSymbol(stockCurrency);
    return (
        <div className="dashboard-row h-[630px] max-h-screen">
            <h3 className='mb-1'>企業データ</h3>
            <div className='mb-4 h-[560px] rounded-md overflow-y-auto'>
                <div className="financial-table ">
                    <div className="column">
                        <div className='header'>全般</div>
                            <FinancialTableRow columnName="国" value={companyInfo?.country} unit="" convertValue={false} isCountry={true} />
                            <FinancialTableRow columnName="業界" value={companyInfo?.industry_fmp?.industry_name} unit="" convertValue={false} />
                            <FinancialTableRow columnName="設立日" value={companyInfo?.establishment_date} unit="" convertValue={false} convertDate={true} />
                            <FinancialTableRow columnName="上場日" value={companyInfo?.listing_date ? companyInfo?.listing_date : companyInfo?.ipodate} unit="" convertValue={false} convertDate={true} />
                            <FinancialTableRow columnName="従業員数" value={financialData?.number_of_employees} unit="人" />
                            <FinancialTableRow columnName="会計基準" value={accountingStandard} unit="" convertValue={false} />
                        </div>
                    <div className="column">
                        <div className='header'>マーケット <span className='font-normal'>({stockPriceData ? formatDateTimeString(stockPriceData?.date, 'm月d日') : '-'})</span></div>
                        <FinancialTableRow columnName="取引市場" value={companyInfo?.exchangeshortname} unit="" convertValue={false} isExchange={true} />
                        {selectableAccounts && selectableAccounts.filter((account) => account.category_1.category === 'market')
                        .map((account) => {
                            if (['per', 'pbr', 'psr'].includes(account.col) && !showMarketData) {
                                return <FinancialTableRow columnName={account.col_name} value={null} unit={account.unit === 'value' ? stockCurrencyUnit : account.unit} />
                            } else {
                                return <FinancialTableRow columnName={account.col_name} value={stockPriceData ? stockPriceData[account.col === 'stock_price'? 'close' : account.col]: null} unit={account.unit === 'value' ? stockCurrencyUnit : account.unit} />
                            }
                        })}
                    </div>
                    <div className="column">
                        <div className="header">損益</div>
                        <div className="content">
                            {selectableAccounts && selectableAccounts.filter((account) => account.category_1.category === 'pl')
                            .map((account) => (
                                <FinancialTableRow columnName={account.col_name} value={financialData[account.col]} unit={account.unit === 'value' ? unit : account.unit} />
                            ))}
                        </div>
                    </div>
                    <div className="column">
                        <div className="header">バランスシート</div>
                        <div className="content">
                            {selectableAccounts && selectableAccounts.filter((account) => account.category_1.category === 'bs')
                                .map((account) => (
                                    <FinancialTableRow columnName={account.col_name} value={financialData[account.col]} unit={account.unit === 'value' ? unit : account.unit} />
                            ))}
                        </div>
                    </div>
                    <div className="column">
                        <div className="header">キャッシュフロー</div>
                        <div className="content">
                            {selectableAccounts && selectableAccounts.filter((account) => account.category_1.category === 'cf')
                            .map((account) => (
                                <FinancialTableRow columnName={account.col_name.replace('キャッシュフロー', 'CF')} value={financialData[account.col]} unit={account.unit === 'value' ? unit : account.unit} />
                            ))}
                        </div>
                    </div>
                    <div className="column">
                        <div className="header">配当</div>
                        <div className="content">
                            {selectableAccounts && selectableAccounts.filter((account) => account.category_1.category === 'dividend')
                                .map((account) => (
                                    account.col === 'dividend_yield' ?
                                    <FinancialTableRow columnName={account.col_name} value={stockPriceData ? stockPriceData[account.col] : null} unit={account.unit} />                                    :
                                    <FinancialTableRow columnName={account.col_name} 
                                        value={(dividendData) ?
                                                (account.col === 'dividend') ? 
                                                    dividendData['adjdividend']
                                                : 
                                                    dividendData[account.col]
                                            : null
                                            } unit={account.unit === 'value' ? stockCurrencyUnit : account.unit} />
                                ))}
                        </div>
                    </div>
                    <div className="column">
                        <div className="header">指標</div>
                        <div className="content">
                            {selectableAccounts && selectableAccounts.filter((account) => account.category_1.category === 'indicator')
                                .map((account) => (
                                    <FinancialTableRow columnName={account.col_name} value={financialData[account.col]} unit={account.unit === 'value' ? unit : account.unit} />
                                ))}
                            
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default FinancialDataSummary